import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCurrencyPesos: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconCurrencyPesos"><Path d="M19.75 11H4.25" stroke="currentColor" strokeWidth="2.5" strokeLinecap="square" strokeLinejoin="round"/><Path d="M19.75 7H4.25" stroke="currentColor" strokeWidth="2.5" strokeLinecap="square" strokeLinejoin="round"/><Path d="M7.25 20.75V3.25H11.9167C15.1383 3.25 17.75 5.86167 17.75 9.08333C17.75 12.305 15.1383 14.9167 11.9167 14.9167H7.72727" stroke="currentColor" strokeWidth="2.5" strokeLinecap="square"/></CentralIconBase>;
});

export default IconCurrencyPesos;
